<template>
  <div class="object-gallery">
    <h3>{{ $t("attr_value_gallery_title") }}</h3>

    <label class="object-card_block app__label" for="objectGalleryLanguage">
      {{ $t("object_attr_lang") }}
    </label>
    <el-select
      id="objectGalleryLanguage"
      v-model="currentLanguage"
      filterable
      @change="changeAttributeLang"
    >
      <el-option
        v-for="item in languages"
        :key="item.id"
        :label="item.name"
        :value="item.id"
      >
      </el-option>
    </el-select>

    <object-gallery-list
      :loading="loading"
      @change="changeGalleryList"
      @changeInModalForm="changeGalleryListInModal"
    />

    <div v-if="isEmptyRequaredField" class="object-gallery__error">
      {{ $t("attr_value_gallery_requared") }}
    </div>

    <div class="object-gallery__actions">
      <div>
        <el-button
          class="object-gallery__actions_item"
          type="primary"
          :disabled="isEdited"
          @click="create"
        >
          {{ $t("attr_value_gallery_add_new") }}
        </el-button>

        <el-button
          class="object-gallery__actions_item"
          type="primary"
          :disabled="isEdited"
          @click="copy"
        >
          {{ $t("attr_value_gallery_copy_photo") }}
        </el-button>
      </div>

      <div>
        <el-button class="object-gallery__actions_item" @click="cancel">
          {{ $t("attr_value_gallery_back") }}
        </el-button>

        <el-button
          class="object-gallery__actions_item"
          type="success"
          :disabled="disabledSave"
          @click="save"
        >
          {{ $t("attr_value_gallery_save") }}
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import ObjectGalleryList from "./ObjectGalleryList.vue";

import { MODE_INIT, MODE_EDIT } from "@/domain/mode.types";

export default {
  name: "ObjectGallery",
  components: {
    ObjectGalleryList
  },
  props: {
    loading: Boolean,
    languages: Array
  },
  data() {
    return {
      mode: MODE_INIT,
      currentLanguage: ""
    };
  },
  computed: {
    isEdited() {
      return this.mode === MODE_EDIT;
    },
    requaredField() {
      return this.$store.state.objectComplexValue.requaredField;
    },
    gallery() {
      return this.$store.state.objectComplexValue.galleryList.gallery;
    },
    isEmptyRequaredField() {
      return this.requaredField && this.gallery.length === 0;
    },
    disabledSave() {
      return !this.isEdited || this.isEmptyRequaredField;
    }
  },
  methods: {
    create() {
      this.$emit("create");
    },
    cancel() {
      this.mode = MODE_INIT;
      this.$emit("cancel");
    },
    save() {
      this.mode = MODE_INIT;
      this.$emit("save");
    },
    copy() {
      this.$emit("copy");
    },
    changeGalleryList() {
      this.mode = MODE_EDIT;
    },
    changeGalleryListInModal() {
      this.$emit("change");
    },
    changeAttributeLang() {
      this.$emit("changeCurrentLanguage", this.currentLanguage);
    },
    setCurrentLang() {
      this.currentLanguage = this.$store.state.objectSetting.currentLanguage;
    }
  },
  mounted() {
    this.setCurrentLang();
  }
};
</script>

<style lang="scss" scoped>
@import "@/css/variables.scss";

.object-gallery {
  padding: $component_padding_on_top $component_padding_on_left;
  height: calc(100% - 30px);
  overflow: auto;

  .object-gallery__actions {
    display: flex;
    justify-content: space-between;
    position: sticky;
    bottom: -22px;
    margin-top: 10px;
    padding: 10px 0;
    text-align: right;
    width: 100%;
    background-color: $free_zone_color;
    z-index: 4;
  }

  .object-gallery__error {
    padding-top: $component_padding_on_top;
    color: $danger_color;
    font-size: $main_font_size;
  }
}
</style>
